import React from 'react';
import Glob from "../../libs/Glob.mjs";
import Creatable from "react-select/creatable";

const TagsEditor = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { value: props.value };
		this.tags2options = this.tags2options.bind(this);
		this.onCreate = this.onCreate.bind(this);
		this.onChange = this.onChange.bind(this);
		this.uid = Glob.generateUid('TagsEditor');
	}
	componentDidMount() {
		Glob.register('knownTags', this.tags2options, this.uid);
		this.tags2options();
	}
	componentWillUnmount() {
		Glob.unregister('knownTags', this.uid);
	}
	tags2options( tags ) {
		if ( typeof tags === 'undefined') tags = Glob.getStatus('knownTags')||[];
		this.setState({ options: tags.map( t => ({ value: t, label: t })) });
	}
	onCreate( t ) {
		const tags = Glob.getStatus('knownTags');
		tags.push( t.trim() );
		const value = this.state.value || [];
		value.push( t.trim() );
		Glob.setStatus('knownTags', tags);
		this.onChange( value );
	}
	onChange( x ) {
		const v = (x && x.length) ? x.map( x => (x?.value ? x.value : x) ) : undefined;
		this.setState( { value: v }, ()=>{
			this.props.onChange( v );
		});
	}
	render() {
		if ( ! this.state.options ) return '';
		return(
			<Creatable
				menuPortalTarget={document.body}
				styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
				defaultValue={ (this.props.value||[]).map( t => ({ value: t, label: t })) }
				value={ (this.state.value||[]).map( t => ({ value: t, label: t })) }
				placeholder={ Glob.label("SelectMulti") }
				className={"flex-grow-1"}
				options={ this.state.options }
				isMulti={true}
				onCreateOption={ this.onCreate }
				onChange={ this.onChange }
				isValidNewOption={ x => (!! x.trim() && x.trim().length > 4 && ! this.state.options.find( o => (o.value === x.trim())) )}
				formatCreateLabel={ (x)=> Glob.label("Add")+` “${ x.trim() }”…` }
			/>
		)
	}
}

export default TagsEditor;